import { TvmFormSubmitResult } from "../components/common/tvm-form/form-definition";
import resolveDb from "../db";
import { DbInstance, SYS_PARTITION_KEY } from "../utils/constants";
import { FORMS } from "../static-config";
import { getSystemForm, setSystemForm } from "./sys-form";

const db = resolveDb(DbInstance.JSON_DB);

export async function createSystem(
	name: string,
	length: string,
	power: string
) {
	const id = await db.create(
		{
			name,
			length,
			power,
		},
		SYS_PARTITION_KEY
	);
	return id;
}

export async function updateSystem(id: string, patch: any) {
	await db.update(id, patch);

	return id;
}

export async function getSystem(id: string) {
	return db.get(id);
}

export async function getForm(formId: string) {
	const form = (FORMS as any)[formId];

	if (!form) {
		throw new Error(`Form not found: ${formId}`);
	}

	return form;
}

export async function getFormResult<T>(systemId: string, formId: string) {
	return getSystemForm<T>(systemId, formId);
}

export async function saveFormResult<T>(
	systemId: string,
	formId: string,
	fieldValues: TvmFormSubmitResult<T>
) {
	return setSystemForm(systemId, formId, fieldValues);
}
